import { BenefitsValueObjectsBenefitTransactionCategoryEnum } from 'generated/resources/graphql'

export type BenefitCategory = BenefitsValueObjectsBenefitTransactionCategoryEnum

export type SupportedMarket = 'es' | 'pt'

export const MEALS_LIMIT_EUR_SPAIN = 22000 // 220€
const TRANSPORTATION_LIMIT_EUR_SPAIN = 13636 // 136.36€
const MEALS_LIMIT_EUR_PORTUGAL = 20400 // 204€
const MARKET_CURRENCIES: Record<SupportedMarket, string> = {
  es: 'EUR',
  pt: 'EUR',
}

export const isSupportedMarket = (market: string | null | undefined): market is SupportedMarket => {
  return market === 'es' || market === 'pt'
}

export const getMarketLimits = (
  market: SupportedMarket
): Partial<Record<BenefitCategory, number>> => {
  switch (market) {
    case 'es':
      return {
        meals: MEALS_LIMIT_EUR_SPAIN,
        transportation: TRANSPORTATION_LIMIT_EUR_SPAIN,
      }
    case 'pt':
      return {
        meals: MEALS_LIMIT_EUR_PORTUGAL,
      }
    default:
      // Default to Spain limits for safety
      return {
        meals: MEALS_LIMIT_EUR_SPAIN,
        transportation: TRANSPORTATION_LIMIT_EUR_SPAIN,
      }
  }
}

export const getAvailableCategories = (market: SupportedMarket): BenefitCategory[] => {
  const limits = getMarketLimits(market)

  return Object.keys(limits).filter(function isBenefitCategory(key): key is BenefitCategory {
    return key in limits
  })
}

export const getMarketCurrency = (market: SupportedMarket): string => {
  return MARKET_CURRENCIES[market]
}
